<div class="modal-dialog modal-xl" class="p-4">
    <div class="h5">
        Voucher Generation
    </div>
    <button type="button" class="close" aria-label="Close" (click)="closeModal()">
        <span aria-hidden="true">&times;</span>
    </button>
    <div #Invoices>
        <div class="edi-lite-item-content" style="max-height: 300px; overflow: auto;">
            <ngx-po-files #filesSimplePO [fileTypes]="purchaseOrder.file_types" [hideAddButton]="true"
                [hideMergeButton]="true" [hideRangeSelect]="true" [isApprovalSection]="true"
                [addFileEventEmitter]="addSubmittedVoucherFileEventEmitter"
                [enableControls]="companyType === 'supplier'" [purchaseOrderId]="purchaseOrder.id"
                [companyType]="companyType" [defaultTag]="'$submitted_voucher_documents'"
                [refreshEvent]="refreshSubmittedVoucherDocuments" [isWithFinancialReport]="true"
                [isFinancialReportSelectable]="true" ></ngx-po-files>
        </div>
    </div>

    <!-- <div class="modal-header">
        <h3>
            Voucher File
        </h3>
        <button class="ml-auto" mat-raised-button color="primary" mat-flat-button
            type="button">
            Confirm
        </button>
    </div> -->
    <div class="col mt-4">
        <mat-form-field>
            <mat-label>File name</mat-label>
            <input type="text" matInput placeholder="File name" [(ngModel)]="fileName" />
            <mat-error *ngIf="invalidFileName">{{invalidFileName}}</mat-error>
        </mat-form-field>
    </div>
    <div class="viewer-container">
        <h3 *ngIf="loading">Loading...</h3>
        <iframe *ngIf="!loading" [src]="pdfSrc" width="100%" height="100%"></iframe>
        <!-- <ng2-pdfjs-viewer  [openFile]="true" #pdfViewer></ng2-pdfjs-viewer> -->
        <!-- [externalWindow]="true" -->
    </div>
    <div class="mt-3">
        <!-- <button class="ml-2" mat-raised-button color="primary" mat-flat-button type="button" (click)="sendVoucher(file)"
            *ngIf="isSignaturesAdded">
            Send generated voucher (without merging)
        </button> -->
        <button class="ml-2" mat-raised-button color="primary" mat-flat-button type="button" (click)="addFile()">
            Save generated voucher as file
        </button>
        <button class="ml-2" mat-raised-button color="primary" mat-flat-button type="button" (click)="mergeFiles()"
            *ngIf="!isMerged && isSignaturesAdded">
            Merge selected files
        </button>

        <button class="ml-2" mat-raised-button color="primary" mat-flat-button type="button"
            (click)="sendVoucher(mergedFile)" *ngIf="isMerged && isSignaturesAdded">
            Send merged file
        </button>

        <button class="ml-2" mat-raised-button mat-flat-button type="button" (click)="mergeFiles()"
            *ngIf="isMerged && isSignaturesAdded">
            Merge again
        </button>
        <button class="ml-2" color="primary" mat-raised-button mat-flat-button type="button"
            (click)="onAddSignaturesClick()" *ngIf="!isSignaturesAdded">
            Add signatures to file
        </button>
    </div>
</div>